import { aiAgentErrorMessage } from '../aiAgentErrorCode'

import { buildSseWireText } from './sseWireFormat'

// 2026-08-27 に実際に発生した障害（Anthropic API のクレジット残高不足）を基にしたSSEフィクスチャ。
// 実際のSDKは assistant メッセージに error: 'billing_error'（本文 'Credit balance is too low'）を乗せ、
// 続く result で subtype: 'error_during_execution' を返した。この記録の再現は
// packages/backend/ai-agent/test/normalizeSdkMessage.test.ts の契約テストで検証する
export const billingErrorSse: string = buildSseWireText([
  { type: 'error', message: aiAgentErrorMessage('AI-0002'), code: 'AI-0002' },
  {
    type: 'done',
    usage: { inputTokens: 100, outputTokens: 50 },
    costUsd: 0.02,
    isError: true,
    durationMs: 1000,
    durationApiMs: 800,
    numTurns: 20,
    errorCode: 'AI-0002',
  },
])
